import { client } from '@/lib/apollo-client';

/**
 * Refetch every mounted `useMyDataQuery`. Under the client-wide `no-cache`
 * policy each one (Sidebar, page, modal) is an independent observer, so a
 * host's own `refetch` leaves the others stale. Resolves to their results.
 */
export function refetchAllMyData() {
  return client.refetchQueries({ include: ['MyData'] });
}
